<template>
  <div>
    <div class="card top-draft" style="margin-bottom: 0px">
      <!-- <div class="col-lg-12 mg-top-1" v-if="power['添加']">
        <b-button variant="primary" @click="toCreate()">
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div> -->

      <div class="col-lg-12 list-header pad-header-bg clearfix">
        <div class="app-list-sort header-item-fix">
          <b-dropdown>
            <template v-slot:button-content>
              <sort-icon />
            </template>
            <b-dropdown-item
              v-for="(item, index) in sortList"
              :key="index"
              @click="listSort(item)"
            >
              <span class="pull-left" v-if="pageParams.sortBy == item.value">
                <i
                  v-if="pageParams.order == 'desc'"
                  class="bx bx-down-arrow-alt font-size-18 pull-left"
                ></i>
                <i
                  v-if="pageParams.order == 'asc'"
                  class="bx bx-up-arrow-alt font-size-18"
                ></i>
              </span>
              <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                item.text
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="header-item-fix">
          <b-form-input
            class="m-r-10"
            size="sm"
            type="text"
            v-model="pageParams.contentKeyword"
            @keyup.enter.native="search"
            placeholder="搜索内容"
          ></b-form-input>
          <b-form-input
            class="m-r-10"
            size="sm"
            type="text"
            v-model="pageParams.title"
            placeholder="搜索标题"
            @keyup.enter.native="search"
          ></b-form-input>
          <b-button size="sm" variant="primary" @click="search()">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
        <div class="header-item-fix">
          <b-form-select
            @change="search()"
            v-model="pageParams.verifyState"
            class="form-select"
            :options="statusList"
            type="text"
          ></b-form-select>
        </div>
      </div>

      <div class="col-lg-12">
        <el-table
          v-loading="tableLoading"
          :data="items"
          style="width: 100%"
          :stripe="true"
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            fixed="left"
            type="selection"
            align="center"
            width="30"
          >
          </el-table-column>
          <el-table-column label="ID" prop="id" width="60" fixed="left">
          </el-table-column>
          <el-table-column label="标题" min-width="200" fixed="left">
            <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <show-repeat-title
                  v-if="repeatTitle"
                  :repeatTitle="repeatTitle"
                  :title="item.row.title"
                ></show-repeat-title>
                <span v-else>{{ item.row.title }}</span>
              </div>
            </template>
            <!-- <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <span>{{ item.row.title }}</span>
              </div>
            </template> -->
          </el-table-column>
          <el-table-column label="封面" width="80">
            <template slot-scope="item">
              <img
                v-if="item.row.image"
                class="w-3-rem"
                :src="`${item.row.image}`"
                alt
              />
              <img
                v-if="!item.row.image"
                class="w-3-rem"
                src="@/assets/images/image-null.jpg"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="100">
            <template slot-scope="item">
              <span v-if="item.row.verifyState == 0">草稿</span>
              <span v-if="item.row.verifyState == 1">通过</span>
              <span v-if="item.row.verifyState == 2">驳回</span>
              <span v-if="item.row.verifyState == 3">待审核</span>
            </template>
          </el-table-column>
          <el-table-column label="显示状态" width="80">
            <template slot-scope="item">
              <el-tooltip
                v-if="power['显示/隐藏']"
                :content="item.row.showState == 1 ? '点击隐藏' : '点击显示'"
              >
                <span
                  @click="batchHide(item.row)"
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt, false, item.row.verifyState)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  @click="batchShow(item.row)"
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </el-tooltip>
              <div v-if="!power['显示/隐藏']">
                <span
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt, false, item.row.verifyState)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发稿人/创建时间" width="152">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.creator || "--" }}</span>
                <span>{{ item.row.createdAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核人/审核时间" width="152">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.verifyName || "--" }}</span>
                <span>{{ item.row.verifiedAt }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
              label="预览链接"
              width="200">
            <template slot-scope="item">
              <a
                  target="_blank "
                  v-if="item.row.previewUrl"
                  :href="item.row.previewUrl"
              >{{ item.row.previewUrl }}</a
              ><span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column label="发布日期" width="158" prop="publishedAt">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="165">
            <template slot-scope="item">
              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 1"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 0"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>

                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="batchExamine(item.row)"
                    v-if="power['提交审核/撤销审核/驳回原因']"
                  >
                    {{ verifyFlag == 1 ? "免审发布" : "提交审核" }}
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 3"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row, 'allModify')"
                  >
                    查看
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="batchRevert(item.row)"
                    v-if="power['撤稿']"
                  >
                    撤销审核
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 2"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>

                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="openReject(item.row)"
                    v-if="power['提交审核/撤销审核/驳回原因']"
                  >
                    驳回原因
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表
        pageCallback 分页组件的回调方法 -->
        <pagination
          class="bath_r_20"
          :isBatch="true"
          :total="pageTotal"
          :batchs="batchs"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>

        <media-dialog ref="media" @pageCallback="pageCallback"></media-dialog>
      </div>
    </div>
    <el-drawer :visible.sync="drawer" size="450px" :direction="direction">
      <iframe
        ref="iframe"
        class="iframe-item"
        :src="rowData.previewUrl"
      ></iframe>
    </el-drawer>
    <!-- 驳回的弹窗 -->
    <examine-reject-dialog ref="examineRejectDialog"></examine-reject-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import article from "@/server/api/article";
import mediaDialog from "./mediaDialog";
import { getPreLink, copyLink, getCopyLink, changeList } from "@/util/fun.js";
import examineRejectDialog from "@/components/examineRejectDialog.vue";
import ShowRepeatTitle from "@/components/ShowRepeatTitle.vue";

/**
 * Contacts-list component
 */
export default {
  components: {
    mediaDialog,
    examineRejectDialog,
    ShowRepeatTitle,
  },
  data() {
    return {
      rowData: {},
      drawer: false,
      direction: "rtl",
      power: "",
      choiceListIds: [], //当前所选择的id
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "0", // 0:草稿，1:初遍池，2：文章列表
        sortBy: "",
        order: "",
        verifyState: "",
        contentKeyword: "",
        mediaId: undefined,
        title: "",
      },
      items: [],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "删除", value: "1" },
        { text: "提交审核", value: "2" },
        { text: "撤销审核", value: "3" },
        // { text: "修改媒体号", value: "4" },
      ],
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "草稿", value: "0" },
        { text: "待审核", value: "3" },
        { text: "驳回", value: "2" },
      ],
      verifyFlag: 0,
      tableLoading: false,
      currentQRcode: "",
      repeatTitle: "",
      pageTotal: 0,
    };
  },

  created() {
    let data = JSON.parse(localStorage.chosedMedia);
    this.verifyFlag = data.verifyFlag;
    this.batchs[2].text = data.verifyFlag == 1 ? "免审发布" : "提交审核";
    if (this.verifyFlag) {
      this.batchs.splice(3, 1);
    }
    this.pageParams.mediaId = data.id;
    this.power = this.utils.currentPower("创作平台-文章发布");
    console.log(this.power);
    this.batchs = this.utils.currentBatchs(this.batchs, this.power);

    //从详情、评论返回文章列表时不重新调用列表接口
    let obj = this.getCache("article-draft");
    if (obj) {
      if (obj.pageParams) {
        this.pageParams = obj.pageParams;
        if (obj.pageParams.title) {
          this.repeatTitle = obj.pageParams.title;
        }
      }
    }
    if (obj && obj.list && obj.list[0]) {
      console.log("使用缓存", obj.list);
      this.items = obj.list;
      this.pageTotal = obj.pageTotal || 0;
      //从详情返回时更新列表数据
      obj = this.getCache("article-edit");
      if (obj && obj.id) {
        //检测编辑的内容id是否在本列表
        let judge = this.items.some((item) => {
          if (item.id == obj.id) {
            return true;
          }
        });
        //获取编辑的内容详情
        article.detail({ id: obj.id }).then((res) => {
          console.log("内容详情", res);
          let detail = res.data;
          if (detail.verifyState != 1) {
            this.addCache("article-edit", "");
            if (judge) {
              //如果审核状态未通过且在本列表则更新对应数据
              this.items = this.items.map((item) => {
                if (item.id == obj.id) {
                  return { ...item, ...detail };
                } else {
                  return item;
                }
              });
              this.updateCache("article-draft", {
                list: this.items,
              });
            } else {
              this.getList(false); //不显示加载图标更新列表
            }
          } else {
            //如果审核状态通过但之前在本列表则删除对应数据
            if (judge) {
              this.pageTotal -= 1;
              this.items = changeList("delete", this.items, [detail.id], "id");
            }
          }
        });
      }
    } else {
      this.getList();
      this.addCache("article-edit", "");
    }
  },
  beforeDestroy() {
    this.addCache("article-draft", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },
  methods: {
    showPre(item) {
      this.rowData.previewUrl = getPreLink(item);
      this.drawer = true;
    },
    async showQRcode(item) {
      let url = getCopyLink(item);
      if (url) {
        this.currentQRcode = await this.$qrCode.toDataURL(url);
      }
    },
    copyUrl(item) {
      copyLink(getCopyLink(item), "链接");
    },
    tableSelectionChange(selectValues) {
      this.choiceListIds = [];
      selectValues.map((val) => {
        this.choiceListIds.push(val.id);
      });
    },
    //获取列表数据
    getList(showLoading) {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      article.list(params).then((resp) => {
        if (resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.updateCache("article-draft", {
              list: this.items,
            });
            this.pageTotal = resp.data.total || 0;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "media") {
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (this.choiceListIds.length < 1) {
          this.info("未选择内容");
          return;
        }
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要删除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击提交审核的处理方法
            this.batchExamine();
          } else {
            Vue.swal("请选择要提交审核的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤销的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要撤稿的内容");
            return;
          }
        }
        if (obj.batch == 4) {
          if (this.choiceListIds.length) {
            //点击修改媒体号的处理方法
            this.$refs.media.showModel(this.choiceListIds, "article");
          } else {
            Vue.swal("请选择要修改的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "articleDetail",
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id },
        });
      }
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.repeatTitle = this.pageParams.title;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.verifyState = "";
      this.pageParams.contentKeyword = "";
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.pageParams.title = "";
      this.repeatTitle = "";
      this.getList();
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "desc"; //默认倒序
      }
      this.getList();
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤销审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.revert(params).then((resp) => {
            if (resp.code === 0) {
              Vue.swal({
                icon: "success",
                title: "操作成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 撤销成功直接更改列表数据
              if (!item) {
                this.choiceListIds = [];
              }
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  verifyState: 0,
                }
              );
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchExamine(item) {
      let msg = this.verifyFlag != 1 ? "确认提交审核?" : "确认免审发布?";
      // 有item代表是单个提审，没item代表多个提审。单个验证是否有关键词，多个不验证。
      if (item) {
        let isWords = false; //有无敏感词
        if (item.words) {
          isWords = true;
        }
        if (item.images) {
          isWords = true;
        }
        if (isWords) {
          // 有敏感词就展示敏感词
          this.contentExamine({
            title: msg,
            cancelText: "取消",
            confirmText: "确定",
            words: item.words,
            images: item.images,
            confirm: () => {
              this.contentSubmitExamine(item);
            },
            cancel: () => {
              // debugger
            },
          });
        } else {
          // 没有敏感词就直接弹出二次确认
          Swal.fire({
            title: msg,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#74788d",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then((result) => {
            if (result.value) {
              this.contentSubmitExamine(item);
            }
          });
        }
      } else {
        Swal.fire({
          title: msg,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#74788d",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.value) {
            this.contentSubmitExamine();
          }
        });
      }
    },

    // 提交审核调用接口
    contentSubmitExamine(item) {
      let params = {};
      if (item) {
        params.ids = [];
        params.ids.push(item.id);
      } else {
        params.ids = this.choiceListIds;
      }
      article.examine(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: this.verifyFlag != 1 ? "提交成功！" : "发布成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          if (!item) {
            this.choiceListIds = [];
          }
          if (this.verifyFlag == 1) {
            // this.getList(); 发布成功时不调用列表接口,直接从列表删除对应内容
            if (this.items.length == params.ids.length) {
              this.getList();
            } else {
              this.pageTotal -= params.ids.length;
              this.items = changeList("delete", this.items, params.ids, "id");
            }
          } else {
            // this.getList(); 提审成功直接更改列表数据
            this.items = changeList("changeAttribute", this.items, params.ids, {
              verifyState: 3,
            });
          }
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    // 驳回原因
    openReject(item) {
      this.$refs.examineRejectDialog.showModel(item);
      // Swal.fire({
      //   title: "驳回原因",
      //   text: item.rejectReason,
      //   confirmButtonColor: "#556ee6",
      // });
    },

    batchHide(item) {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.hide(params).then((resp) => {
            if (resp.code === 0) {
              this.success("隐藏成功");
              // this.getList(); 修改状态成功不刷新列表，直接更改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 0,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchShow(item) {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.show(params).then((resp) => {
            if (resp.code === 0) {
              this.success("显示成功");
              // this.getList(); 修改状态后不调用列表接口，直接改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 1,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.remove(params).then((resp) => {
            if (resp.code === 0) {
              this.success("删除成功");
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              this.warning(resp.msg || "删除失败");
            }
          });
        }
      });
    },
    // 去文章的评论列表
    toComments(item) {
      this.$router.push({
        name: "articleComments",
        query: { id: item.id },
      });
    },
  },
};
</script>
<style scoped>
.iframe-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
::v-deep .el-table thead .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table thead .el-table__cell:first-child .cell .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep
  .el-table
  tbody
  > .el-table__row
  .el-table__cell:first-child
  .cell
  .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .el-table thead .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:last-child .cell {
  padding-right: 0px !important;
}
</style>
